var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [
            { title: "Fatura Yönetimi", path: "/billing" },
            { title: "Planlar" },
          ],
          select: true,
        },
      }),
      _vm._v(" "),
      _vm.creditCardRequired
        ? _c("CreditCardNeeded", {
            on: {
              close: function ($event) {
                _vm.creditCardRequired = null
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.cancelPlanModal
        ? _c("CancelPlanModal", {
            on: {
              confirm: function ($event) {
                return _vm.unsubscribe(_vm.cancelPlanModal)
              },
              reject: function ($event) {
                _vm.cancelPlanModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.subscribePlanModal
        ? _c("CreatePlanModal", {
            attrs: { planPeriod: _vm.period, plan: _vm.subscribePlanModal },
            on: {
              confirm: function ($event) {
                return _vm.subscribe(_vm.subscribePlanModal)
              },
              reject: function ($event) {
                _vm.subscribePlanModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showWarn
        ? _c(
            "DowngradeWarn",
            {
              on: {
                close: function ($event) {
                  _vm.showWarn = null
                },
                forward: _vm.forwardPage,
              },
            },
            [
              _vm.showWarn == "supsis"
                ? [
                    _vm._v(
                      "\n            Paketiniz düşürülemiyor. Paketinizi düşürmek için lütfen Temsilcilerinizden bir kaçını siliniz veya\n            devredışı bırakınız.\n        "
                    ),
                  ]
                : _vm.showWarn == "whatsapp"
                ? [
                    _vm._v(
                      "\n            Paketiniz düşürülemiyor. Paketinizi düşürmek için lütfen Whatsapp Kanalarınızdan bir kaçını siliniz.\n        "
                    ),
                  ]
                : _vm.showWarn == "whatsapp-business"
                ? [
                    _vm._v(
                      "\n            Paketiniz düşürülemiyor. Paketinizi düşürmek için lütfen Whatsapp Business Kanalarınızdan bir kaçını\n            siliniz.\n        "
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "billing-plans" }, [
        _c("div", { staticClass: "title" }, [
          _c("div", [
            _c("div", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.type
                      ? _vm.type
                          .split("-")
                          .map(function (c) {
                            return c[0].toUpperCase() + c.slice(1).toLowerCase()
                          })
                          .join(" ")
                      : ""
                  ) +
                  "\n                    Planınızı Seçiniz\n                "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "plan-select-options" }, [
              _c(
                "div",
                { staticStyle: { width: "max-content" } },
                [
                  _c("div", { staticClass: "option-title" }, [
                    _vm._v("Şunun için hesapla:"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "option-description" }, [
                    _vm._v("Yıllık paketlerde %30 indirimi yakala!"),
                  ]),
                  _vm._v(" "),
                  _c("ChangePlan", {
                    model: {
                      value: _vm.period,
                      callback: function ($$v) {
                        _vm.period = $$v
                      },
                      expression: "period",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              ["supsis", "whatsapp-business", "whatsapp"].includes(_vm.type)
                ? _c("div", { staticStyle: { width: "max-content" } }, [
                    _c("div", { staticClass: "option-title" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.type == "supsis"
                              ? "Temsilci Sayınız"
                              : ["whatsapp-business", "whatsapp"].includes(
                                  _vm.type
                                )
                              ? "Kanal Sayısı"
                              : ""
                          ) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "option-description" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.type == "supsis"
                              ? "Maximun konuşacak temsilci sayısı"
                              : ["whatsapp-business", "whatsapp"].includes(
                                  _vm.type
                                )
                              ? "Whatsapp kanal sayısı"
                              : ""
                          ) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    ["supsis"].includes(_vm.type)
                      ? _c("div", { staticClass: "classic-counter-group" }, [
                          _c(
                            "div",
                            {
                              staticClass: "classic-counter-button",
                              on: {
                                click: function ($event) {
                                  _vm.details.agentCount > 1 &&
                                    _vm.details.agentCount--
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                -\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("a-input-number", {
                                staticClass: "counter",
                                attrs: { min: 1 },
                                model: {
                                  value: _vm.details.agentCount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.details, "agentCount", $$v)
                                  },
                                  expression: "details.agentCount",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "classic-counter-button",
                              on: {
                                click: function ($event) {
                                  _vm.details.agentCount++
                                },
                              },
                            },
                            [_vm._v("+")]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    ["whatsapp-business", "whatsapp"].includes(_vm.type)
                      ? _c("div", { staticClass: "classic-counter-group" }, [
                          _c(
                            "div",
                            {
                              staticClass: "classic-counter-button",
                              on: {
                                click: function ($event) {
                                  _vm.details.whatsappChannel > 1 &&
                                    _vm.details.whatsappChannel--
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                -\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("a-input-number", {
                                staticClass: "counter",
                                attrs: { min: 1 },
                                model: {
                                  value: _vm.details.whatsappChannel,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.details,
                                      "whatsappChannel",
                                      $$v
                                    )
                                  },
                                  expression: "details.whatsappChannel",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "classic-counter-button",
                              on: {
                                click: function ($event) {
                                  _vm.details.whatsappChannel++
                                },
                              },
                            },
                            [_vm._v("+")]
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    followCursor: true,
                    placement: "bottom-end",
                    maxWidth: 500,
                    arrow: true,
                    offset: "0, 15",
                  },
                  expression:
                    "{ followCursor: true, placement: 'bottom-end', maxWidth: 500, arrow:true, offset: '0, 15' }",
                },
              ],
              staticClass: "lightbulb",
              attrs: { content: _vm.$t("chatbotv2.plansVTippyContent") },
            },
            [
              _c("div", { staticClass: "material-icons" }, [
                _vm._v("lightbulb"),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            { staticClass: "supsis-plans" },
            _vm._l(_vm.allPlans[_vm.type], function (plan, index) {
              return _c("Card", {
                key: index,
                attrs: { plan: plan, period: _vm.period, details: _vm.details },
                on: {
                  subscribe: _vm.onSubscribe,
                  unsubscribe: function (payload) {
                    return (_vm.cancelPlanModal = payload)
                  },
                },
              })
            }),
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }